import React from 'react'
import {Link} from 'gatsby'
import starIcon from '../../assets/images/icons/star-icon.png'
import open_source_icon from '../../assets/images/icons/opensource_source_icon.svg'
import coverage_icon from '../../assets/images/icons/n_m_coverage_icon.svg'
import code_cognita_icon from '../../assets/images/icons/code_cognita_icon.svg'

const OurSolutions = () => {
    return (
        <section className="solutions-area pb-70">
            <div className="container">
                <div className="section-title">
                    <span className="sub-title">
                        <img src={starIcon} alt="star" /> 
                        Our Solutions
                    </span>
                    {/* <h2>We Different From Others Should Choose Us</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p> */}
                </div>

                <div className="row">
                    <div className="col-lg-4 col-sm-6">
                        <div className="single-solutions-box">
                            <div className="icon">
                            <img src={code_cognita_icon} alt="banner" width="80"/>
                            </div>
                            <h3>
                                <Link to="/service-details">
                                    Code Cognita
                                </Link>
                            </h3>
                            <p>Make it Easyer to locate your Features in code with a map, with Cover-Rest's Code Cognita.</p>

                            {/* <Link to="/service-details" className="view-details-btn">
                                View Details
                            </Link> */}
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6">
                        <div className="single-solutions-box">
                            <div className="icon">
                            <img src={coverage_icon} alt="banner" width="80"/>
                            </div>

                            <h3>
                                <Link to="/service-details">
                                    n:m Coverage
                                </Link>
                            </h3>

                            <p>There are just to many Coverage tools for to many Language simplefy it with Cover-Rest with one Api for all.</p>
                            
                            {/* <Link to="/service-details" className="view-details-btn">
                                View Details
                            </Link> */}
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 offset-lg-0 offset-sm-3">
                        <div className="single-solutions-box">
                            <div className="icon">
                            <img src={open_source_icon} alt="banner" width="80"/>
                            </div>

                            <h3>
                                <Link to="/service-details">
                                    Opensource
                                </Link>
                            </h3> 

                            <p>Cover-Rest is an opensource project funded by the Prototypefund</p>
                            
                            {/* <Link to="/service-details" className="view-details-btn">
                                View Details
                            </Link> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default OurSolutions;